export default __webpack_public_path__ + "static/media/ontime-logo.2e3b9fd8.svg";